import { socket } from "../App";
import {
  RequestCurrentMusicChange,
  RequestCurrentMusicGet,
  RequestCurrentMusicNewTimeCode,
  RequestCurrentPlaylistAddMusic,
  RequestCurrentPlaylistChange,
  RequestCurrentPlaylistGet,
  RequestCurrentPlaylistNewOrder,
  RequestPlaylistCreate,
  RequestPlaylistGetAll,
} from "../types/clientRequest.type";
import { Playlist } from "../types/global.type";

export const RequestFactory = {
  currentMusic: {
    change: (musicId: string) => {
      const data: RequestCurrentMusicChange = {
        target: "CURRENT_MUSIC",
        request: "CHANGE",
        payload: {
          musicId: musicId,
        },
      };
      socket.emit("message", data);
    },
    get: () => {
      const data: RequestCurrentMusicGet = {
        target: "CURRENT_MUSIC",
        request: "GET",
      };
      socket.emit("message", data);
    },
    newTimeCode: (timeCode: number, senderId: string) => {
      const data: RequestCurrentMusicNewTimeCode = {
        target: "CURRENT_MUSIC",
        request: "NEW_TIME_CODE",
        payload: {
          timeCode: timeCode,
          senderId: senderId,
        },
      };
      socket.emit("message", data);
    },
  },
  currentPlaylist: {
    addMusic: (playlistId: number, url: string) => {
      const data: RequestCurrentPlaylistAddMusic = {
        target: "CURRENT_PLAYLIST",
        request: "ADD_MUSIC",
        payload: {
          playlistId: playlistId,
          musicURL: url,
        },
      };
      socket.emit("message", data);
    },
    get: () => {
      const data: RequestCurrentPlaylistGet = {
        target: "CURRENT_PLAYLIST",
        request: "GET",
        payload: {},
      };
      socket.emit("message", data);
    },
    change: (playlistId: number, random: boolean = false) => {
      const data: RequestCurrentPlaylistChange = {
        target: "CURRENT_PLAYLIST",
        request: "CHANGE",
        payload: {
          playlistId: playlistId,
          random,
        },
      };
      socket.emit("message", data);
    },
    sendNewOrder: (playlist: Playlist, senderId: string) => {
      const data: RequestCurrentPlaylistNewOrder = {
        target: "CURRENT_PLAYLIST",
        request: "NEW_ORDER",
        payload: {
          playlist,
          senderId,
        },
      };
      socket.emit("message", data);
    },
  },
  playlist: {
    create: (name: string) => {
      const data: RequestPlaylistCreate = {
        target: "PLAYLIST",
        request: "CREATE",
        payload: {
          name: name,
        },
      };
      socket.emit("message", data);
    },
    getAll: () => {
      const data: RequestPlaylistGetAll = {
        target: "PLAYLIST",
        request: "GETALL",
        payload: {},
      };
      socket.emit("message", data);
    },
  },
};
